<template>
  <a-modal
    class="client-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="isVisibleAdd"
    :footer="null"
    :title="title"
    :body-style="{minHeight:'300px'}"
    @cancel="$emit('onCancel')"
  >
    <div ref="SelectRef">
      <a-form
        :form="form"
      >
        <a-form-item
          v-for="item in formData.filter(item=>item.type!==2 && item.type!==3 && item.type!==4)"
          :key="item.id"
          :colon="false"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
          :label="item.label"
        >
          <a-input
            v-if="item.type === 0"
            v-decorator="[
              `${item.id}`,
              {
                initialValue: item.value,
                rules: [{ required: true, message: item.hint }],
              },
            ]"
            :placeholder="item.hint"
          />
          <a-select
            v-if="item.type === 1"
            v-decorator="[
              `${item.id}`,
              {
                initialValue: item.value,
                rules: [{ required: true, message: item.hint }],
              },
            ]"
            :placeholder="item.hint"
          >
            <a-select-option
              v-for="option in JSON.parse(item.configDataDesc)"
              :key="option.key"
              :value="option.key"
            >
              {{ option.name }}
            </a-select-option>
          </a-select>
          <a-date-picker
            v-if="item.type === 5"
            v-decorator="[
              `${item.id}`,
              {
                initialValue: item.value ? $Moment(item.value) : undefined,
                rules: [{ required: true, message: item.hint }],
              },
            ]"
            :format="JSON.parse(item.configViewDesc).format.js"
          />
          <special-select
            v-if="item.type === 6"
            v-decorator="[
              `${item.id}`,
              {
                initialValue: item.value,
                rules: [{ required: true, message: item.hint }],
              },
            ]"
            :select-data="item"
          />
          <a-select
            v-if="item.type === 7"
            v-decorator="[
              `${item.id}`,
              {
                initialValue: item.value ? item.value.split(',') : undefined,
                rules: [{ required: true, message: item.hint }],
              },
            ]"
            mode="multiple"
            :placeholder="item.hint"
          >
            <a-select-option
              v-for="option in JSON.parse(item.configDataDesc)"
              :key="option.key"
              :value="option.key"
            >
              {{ option.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <div
          v-show="formData1.some(item => item.type===2||item.type===3||item.type===4)"
          class="note"
        >
          定位和照片请到移动端添加
        </div>
        <form-button
          :btn-is-loading="btnIsLoading"
          @onCancel="$emit('onCancel')"
          @onSubmit="$emit('onSubmit')"
        />
      </a-form>
    </div>
  </a-modal>
</template>

<script>
import SpecialSelect from './../components/SpecialSelect';
export default {
  components: {SpecialSelect},
  props: ['title', 'isVisibleAdd', 'formData', 'btnIsLoading', 'formData1'],
  data() {
    return {
      data: [],
      form: this.$form.createForm(this),
    };
  },
  mounted(){
    console.log(this.$refs.SelectRef);
  },
  methods: {
    // type:6
    getProductionName(list, configDataDesc) {
      let data;
      const selectId = this.form.getFieldValue('12');
      const selectData = configDataDesc.find((item) => item.key === selectId);
      if(Array.isArray(selectData[list.key])){
        data= selectData[list.key].map((item)=>{
          return item.name;
        }).join();
      }else{
        data=selectData[list.key];
      }
      console.log('data', data);
      return data;
    },
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
  .textarea {
    font-size: 12px;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
    position: relative;
    top: -37px;
    right: -550px;
  }
  .note {
    text-align: center;
    padding-bottom: 20px;
    color: rgba(195, 199, 213, 1);
  }
}
</style>
